
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service-faq",
      function () {
        return require("private-next-pages/customer-service-faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service-faq"])
      });
    }
  